import create from "zustand";

const [useBarchartTooltip] = create(set => ({
  index: null,
  select: index => set({ index }),
  unselect: () => set({ index: null }),
}));

export { useBarchartTooltip };
